import styled, { keyframes, css } from 'styled-components';
import { LABEL } from 'common/base';
import { SIZE } from 'common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { BUTTON_PRIMARY,BUTTON_SECONDARY } from 'components/TCButton/styles';

const appear = keyframes`
    from {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    to { transform: translateY(0); opacity: 1;}
`

const appearAnimation = props =>
    css`
    ${appear} 0.350s ease-out;
`
const disappear = keyframes`
    from { transform: translateY(0); opacity: 1;}
    to {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    
`

const disappearAnimation = props =>
    css`
    ${disappear} 0.350s ease-out;
`

export interface ContainerProps {
    shouldShow: boolean;
}
export const Container = styled.div`
    display:flex;
    flex-flow: column;
    background: #FFF;
    width: ${SIZE.EIGHTY_TWO}px;
    min-height: ${SIZE.THIRTY}px;

    border: 1px solid #A0A0A0;
    padding: ${SIZE.SIX}px;
    animation: ${(props: ContainerProps) => props.shouldShow ? appearAnimation : disappearAnimation};
    animation-fill-mode: forwards;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    
`

export const TitleContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content: flex-start;
`
export const Title = styled(LABEL)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 24px;
    line-height: 2;
    letter-spacing: 2.5px;
    color: #373f53;
`
export const Body = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${SIZE.TWO}px 0 ${SIZE.ONE}px 0;
    align-items: flex-start;
`
export const BodyText = styled(LABEL)`
    width: 100%;
    font-size: 18px;
    text-align: left;
    color: #000000;
    font-family: ${DEFAULT_FONT_FAMILY};
    
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
`;

export const Notice = BodyText;

export const ErrorText = styled.div`
    width: 100%;
    margin-top: 10px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #FC583E;
`;

export const SuccessText = styled.div`
    width: 100%;
    margin-top: 10px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #3EAF6A;
`;

export const ButtonContainer = styled.span`
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    font-size: 18px;
    align-items: center;
    height: ${SIZE.SIX}px;
    padding-top: ${SIZE.ONE}px;
    ${BUTTON_SECONDARY} {
        margin-right: ${SIZE.ONE}px
        font-family: Rubik;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
    }
    ${BUTTON_PRIMARY} {
        margin-right: ${SIZE.ONE}px
        font-family: Rubik;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
    }
`

export const ImageContainer = styled.div`
    width: 202px;
    height: 175px;
    margin: 25px 45px 0 0;
    object-fit: contain;

`

export const MainContainer = styled.span`
    display: flex;
    flex-flow: row;
`

export const TextContainer = styled.span`
    display: flex;
    flex-flow: column;
    margin-top: ${SIZE.ONE}px;
`

export const Field = styled.label`
    color: #ff7319;
`

export const TitleChanged = styled.div`
    margin-top: 20px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #525252;
`;

export const FieldChanged = styled.div`
    margin-top: 14px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
`;

